<div (window:resize)="onResize()"></div>

@for (i of createArrayNumbersOfLength(numberOfEmptyRows); track i) {
  <li>
    <i class="material-icons"></i>
  </li>
}

<!-- Save tabView -->
<li [ngClass]="'nav-item'">
  <a (click)="onBtnOpenModalNewTableView(modalNewTableView)" class="nav-link link-sidebar">
    <i class="material-icons">add_photo_alternate</i>
    <span class="hidden-md-down" ui-test-id="saveTableViewBtn">{{ 'TABLE_VIEW_SAVE_TABLE_VIEW' | translate }}</span>
  </a>
</li>

<!-- Edit tabView -->
<li [ngClass]="getSelectedTableView() !== null ? 'nav-item' : 'nav-item disabled'">
  <a (click)="onBtnOpenModalEditTableView(modalEditTableView)" class="nav-link link-sidebar">
    <i class="material-icons">mode_edit</i>
    <span class="hidden-md-down" ui-test-id="editTableViewBtn">{{ 'TABLE_VIEW_EDIT_TABLE_VIEW' | translate }}</span>
  </a>
</li>

<!-- Reset default -->
<li [ngClass]="isBtnResetDefaultTableViewDisabled ? 'nav-item disabled' : 'nav-item'">
  <a (click)="onBtnResetDefaultTableView()" class="nav-link link-sidebar">
    <i class="material-icons">login</i>
    <span class="hidden-md-down" ui-test-id="resetTableViewDefaultBtn">
      {{ 'TABLE_VIEW_RESET_TABLE_VIEW_DEFAULT' | translate }}
    </span>
  </a>
</li>

<!-- Reset system default -->
<li [ngClass]="'nav-item'">
  <a (click)="onBtnResetSystemDefaultTableView()" class="nav-link link-sidebar">
    <i class="material-icons">logout</i>
    <span class="hidden-md-down" ui-test-id="resetTableViewSystemDefaultBtn">
      {{ 'TABLE_VIEW_RESET_TABLE_VIEW_SYSTEM_DEFAULT' | translate }}
    </span>
  </a>
</li>

<!-- Delete TabView -->
<li [ngClass]="getSelectedTableView() !== null ? 'nav-item' : 'nav-item disabled'">
  <a (click)="onBtnDeleteSelectedTableView()" class="nav-link link-sidebar">
    <i class="material-icons">delete</i>
    <span class="hidden-md-down" ui-test-id="deleteTableViewBtn">{{ 'TABLE_VIEW_DELETE_TABLE_VIEW' | translate }}</span>
  </a>
</li>

<ng-template #modalNewTableView>
  <tur-generic-modal-content
    [acceptanceAllowed]="formGroupNewTableView.valid"
    (confirm)="onBtnSaveTableView()"
    (cancel)="onBtnCancelNewTableView()"
    id="ModalNewTableView"
    acceptButtonLbl="{{ 'SAVE' | translate }}"
    cancelButtonLbl="{{ 'CANCEL' | translate }}"
    confirmationMessage=""
    modalTitle="{{ 'TABLE_VIEW_SAVE_TABLE_VIEW_TITLE' | translate }}">
    <form [formGroup]="formGroupNewTableView">
      <div class="form-group">
        <pas-input
          [(ngModel)]="txtTableViewName"
          id="newTableViewNameInput"
          formControlName="formControlTxtTableViewName"
          subLabel="{{ 'TABLE_VIEW_MODAL_TITLE_SAVE' | translate }}"></pas-input>

        @if (formGroupNewTableView.controls['formControlTxtTableViewName'].invalid) {
          <span style="color: red">
            @if (formGroupNewTableView.controls['formControlTxtTableViewName'].errors.required) {
              <div>
                {{ 'TABLE_VIEW_VALIDATOR_ENTER_NAME' | translate }}
              </div>
            }
            @if (formGroupNewTableView.controls['formControlTxtTableViewName'].errors.pattern) {
              <div>
                {{ 'TABLE_VIEW_VALIDATOR_INVALID_CHARACTERS' | translate }}
              </div>
            }
            @if (formGroupNewTableView.controls['formControlTxtTableViewName'].errors.nameExist) {
              <div>
                {{ 'TABLE_VIEW_VALIDATOR_ALREADY_EXISTS' | translate }}
              </div>
            }
            @if (formGroupNewTableView.controls['formControlTxtTableViewName'].errors.maxlength) {
              <div>
                {{ 'TABLE_VIEW_VALIDATOR_MAX_LENGTH' | translate }}
              </div>
            }
            @if (formGroupNewTableView.controls['formControlTxtTableViewName'].errors.nameNotAllowed) {
              <div>
                {{ 'TABLE_VIEW_VALIDATOR_NOT_ALLOWED' | translate }}
              </div>
            }
          </span>
        }
      </div>

      <div class="form-group">
        <pas-checkbox
          [(ngModel)]="chkIsDefaultView"
          (ngModelChange)="onChkIsDefaultViewOnModals($event, save)"
          id="newTableViewIsDefaultChk"
          formControlName="formControlChkIsDefaultView"
          label="{{ labelTextForChkIsDefaultView }}"
          size="small"></pas-checkbox>
      </div>
    </form>
  </tur-generic-modal-content>
</ng-template>

<ng-template #modalEditTableView>
  <tur-generic-modal-content
    [acceptanceAllowed]="isBtnOkOnModalEditTableViewEnabled()"
    (confirm)="onBtnUpdateTableView()"
    (cancel)="onBtnCancelEditTableView()"
    id="ModalEditTableView"
    acceptButtonLbl="{{ 'SAVE' | translate }}"
    cancelButtonLbl="{{ 'CANCEL' | translate }}"
    confirmationMessage=""
    modalTitle="{{ 'TABLE_VIEW_MODAL_TITLE_EDIT' | translate }}">
    <form [formGroup]="formGroupEditTableView">
      <div class="form-group">
        <pas-input
          [(ngModel)]="txtTableViewName"
          id="editTableViewNameInput"
          formControlName="formControlTxtTableViewName"
          subLabel="{{ 'TABLE_VIEW_MODAL_TEXTFIELD_LABEL_EDIT' | translate }}"></pas-input>

        @if (formGroupEditTableView.controls['formControlTxtTableViewName'].invalid) {
          <span style="color: #ff0000">
            @if (formGroupEditTableView.controls['formControlTxtTableViewName'].errors.required) {
              <div>
                {{ 'TABLE_VIEW_VALIDATOR_ENTER_NAME' | translate }}
              </div>
            }
            @if (formGroupEditTableView.controls['formControlTxtTableViewName'].errors.pattern) {
              <div>
                {{ 'TABLE_VIEW_VALIDATOR_INVALID_CHARACTERS' | translate }}
              </div>
            }
            @if (formGroupEditTableView.controls['formControlTxtTableViewName'].errors.nameExist) {
              <div>
                {{ 'TABLE_VIEW_VALIDATOR_ALREADY_EXISTS' | translate }}
              </div>
            }
            @if (formGroupEditTableView.controls['formControlTxtTableViewName'].errors.maxlength) {
              <div>
                {{ 'TABLE_VIEW_VALIDATOR_MAX_LENGTH' | translate }}
              </div>
            }
            @if (formGroupEditTableView.controls['formControlTxtTableViewName'].errors.nameNotAllowed) {
              <div>
                {{ 'TABLE_VIEW_VALIDATOR_NOT_ALLOWED' | translate }}
              </div>
            }
          </span>
        }
      </div>

      <div class="form-group">
        <pas-checkbox
          [(ngModel)]="chkIsDefaultView"
          (ngModelChange)="onChkIsDefaultViewOnModals($event, update)"
          id="editTableViewIsDefaultChk"
          formControlName="formControlChkIsDefaultView"
          label="{{ labelTextForChkIsDefaultView }}"
          size="small"></pas-checkbox>
      </div>

      @if (showMessageModifiedTableMetadata) {
        <div class="form-group">
          <pas-checkbox
            [(ngModel)]="chkSaveModifiedTableMetadata"
            id="editTableViewSaveModifiedTableMetadataChk"
            formControlName="formControlChkSaveModifiedTableMetadata"
            label="{{ 'TABLE_VIEW_MODAL_METADATA_CHANGED' | translate }}"
            size="small"></pas-checkbox>
        </div>
      }
    </form>
  </tur-generic-modal-content>
</ng-template>
